export const add = (valueA, valueB) => valueA + valueB;
export const subtract = (valueA, valueB) => valueA - valueB;

const createBreakdownLookupMap = breakdown => {
	return breakdown.reduce((milestoneMap, milestone) => {
		if (milestone.roleBreakdown) {
			milestoneMap[milestone.milestoneId] = milestone.roleBreakdown.reduce((roleMap, role) => {
				roleMap[role.roleId] = role.breakdown.reduce((dateMap, date) => {
					dateMap[date.date] = date.value;
					return dateMap;
				}, {});
				return roleMap;
			}, {});
		} else if (milestone.expenseCategoryBreakdown) {
			milestoneMap[milestone.milestoneId] = milestone.expenseCategoryBreakdown.reduce((expenseCategoryMap, expenseCategory) => {
				expenseCategoryMap[expenseCategory.expenseCategoryId] = expenseCategory.breakdown.reduce((dateMap, date) => {
					dateMap[date.date] = date.value;
					return dateMap;
				}, {});
				return expenseCategoryMap;
			}, {});
		}
		return milestoneMap;
	}, {});
};

const combineMilestones = (breakdown, combinedMilestones = {}) => {
	breakdown.forEach(milestone => {
		if (combinedMilestones[milestone.milestoneId] === undefined) {
			combinedMilestones[milestone.milestoneId] = {};
		}
		if (milestone.roleBreakdown) {
			milestone.roleBreakdown.forEach(role => {
				if (combinedMilestones[milestone.milestoneId][role.roleId] === undefined) {
					combinedMilestones[milestone.milestoneId][role.roleId] = {};
				}
				role.breakdown.forEach(date => {
					if (combinedMilestones[milestone.milestoneId][role.roleId][date.date] === undefined) {
						combinedMilestones[milestone.milestoneId][role.roleId][date.date] = true;
					}
				});
			});
		} else if (milestone.expenseCategoryBreakdown) {
			milestone.expenseCategoryBreakdown.forEach(expenseCategory => {
				if (combinedMilestones[milestone.milestoneId][expenseCategory.expenseCategoryId] === undefined) {
					combinedMilestones[milestone.milestoneId][expenseCategory.expenseCategoryId] = {};
				}
				expenseCategory.breakdown.forEach(date => {
					if (combinedMilestones[milestone.milestoneId][expenseCategory.expenseCategoryId][date.date] === undefined) {
						combinedMilestones[milestone.milestoneId][expenseCategory.expenseCategoryId][date.date] = true;
					}
				});
			});
		}
	});
	return anotherBreakdown => (anotherBreakdown !== undefined ? combineMilestones(anotherBreakdown, combinedMilestones) : combinedMilestones);
};

const getBreakdownValue = (breakdownLookupMap, milestoneId, roleId, date) => {
	if (breakdownLookupMap[milestoneId] !== undefined && breakdownLookupMap[milestoneId][roleId] !== undefined && breakdownLookupMap[milestoneId][roleId][date] !== undefined) {
		return breakdownLookupMap[milestoneId][roleId][date];
	}

	return 0;
};

export const createMilestoneRoleVariance = (breakdownA, breakdownB, operation) => {
	const combinedMilestones = combineMilestones(breakdownA)(breakdownB)();
	const breakdownLookupMapA = createBreakdownLookupMap(breakdownA);
	const breakdownLookupMapB = createBreakdownLookupMap(breakdownB);

	return Object.keys(combinedMilestones).map(milestoneId => {
		return {
			milestoneId,
			roleBreakdown: Object.keys(combinedMilestones[milestoneId]).map(roleId => {
				return {
					roleId,
					breakdown: Object.keys(combinedMilestones[milestoneId][roleId]).map(date => {
						const valueA = getBreakdownValue(breakdownLookupMapA, milestoneId, roleId, date);
						const valueB = getBreakdownValue(breakdownLookupMapB, milestoneId, roleId, date);
						const value = operation(valueA, valueB);

						return {
							date,
							value,
						};
					}),
				};
			}),
		};
	});
};

export const createMilestoneExpenseCategoryVariance = (breakdownA, breakdownB, operation) => {
	const combinedMilestones = combineMilestones(breakdownA)(breakdownB)();
	const breakdownLookupMapA = createBreakdownLookupMap(breakdownA);
	const breakdownLookupMapB = createBreakdownLookupMap(breakdownB);

	return Object.keys(combinedMilestones).map(milestoneId => {
		return {
			milestoneId,
			expenseCategoryBreakdown: Object.keys(combinedMilestones[milestoneId]).map(expenseCategoryId => {
				return {
					expenseCategoryId,
					breakdown: Object.keys(combinedMilestones[milestoneId][expenseCategoryId]).map(date => {
						const valueA = getBreakdownValue(breakdownLookupMapA, milestoneId, expenseCategoryId, date);
						const valueB = getBreakdownValue(breakdownLookupMapB, milestoneId, expenseCategoryId, date);
						const value = operation(valueA, valueB);

						return {
							date,
							value,
						};
					}),
				};
			}),
		};
	});
};
